// libraries.
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MapContext, PolygonF } from '@react-google-maps/api';

// components.
import { PolygonIdLabel } from '@domains/google-map';

// slices.
import { getSelectedAuditPolygon } from '@domains/audit-polygons/store/slices/auditPolygons.slice';
import { getListPolygons } from '@domains/save-polygons';

const HIGHLIGHT_OPTIONS: google.maps.PolygonOptions = {
  fillColor: '#DC3545',
  fillOpacity: 0.25,
  strokeColor: '#DC3545',
  strokeWeight: 2,
  zIndex: 200,
};

/**
 * Dibuja en el mapa el polígono inválido seleccionado en la auditoría usando
 * sus propias coordenadas (no depende de la query por zona, que podría
 * excluirlo) y centra el mapa sobre él. Se monta dentro de <GoogleMap>.
 */
export const AuditSelectedPolygon = () => {
  const map = useContext(MapContext);
  const selected = useSelector(getSelectedAuditPolygon);
  const listPolygons = useSelector(getListPolygons);
  const coords = selected?.polygon ?? [];

  useEffect(() => {
    if (map && coords.length) {
      const bounds = new window.google.maps.LatLngBounds();
      coords.forEach(coord => bounds.extend(coord));
      map.fitBounds(bounds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  // Si la zona ya cargó este polígono, el flujo normal lo dibuja (y es
  // editable): no pintamos el overlay para no duplicarlo/encimarlo.
  const alreadyRendered =
    selected != null &&
    listPolygons.some(
      polygon => String(polygon.polygon_id) === String(selected.polygon_id)
    );

  if (!coords.length || alreadyRendered) return null;

  const path = coords.map(point => ({ lat: point.lat, lng: point.lng }));

  return (
    <>
      <PolygonF path={path} options={HIGHLIGHT_OPTIONS} />
      <PolygonIdLabel
        id={selected?.polygon_id ?? ''}
        path={path}
        color="#DC3545"
      />
    </>
  );
};
